import { type BrandVariants, createLightTheme, type Theme } from '@fluentui/react-components';

/** The one blue (#1D5C8C at 80, Fluent's brand slot for primary buttons, links and the current page). */
const brand: BrandVariants = {
  10: '#03090e', 20: '#081a28', 30: '#0c2a42', 40: '#10375a', 50: '#134470', 60: '#164f80', 70: '#1a5686', 80: '#1d5c8c',
  90: '#356d99', 100: '#4d7ea6', 110: '#6590b3', 120: '#7ea2c0', 130: '#97b4cd', 140: '#b1c7da', 150: '#cbdae7', 160: '#e5edf4'
};

const base: Theme = createLightTheme(brand);

/** Neutral greys, IBM Plex Sans, and the brand blue only where the eye should go. */
export const theme: Theme = {
  ...base,
  fontFamilyBase: '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", sans-serif',
  fontFamilyMonospace: '"IBM Plex Mono", ui-monospace, Menlo, monospace',
  colorNeutralForeground1: '#16202C',
  colorNeutralForeground2: '#3D4E60',
  colorNeutralForeground3: '#5A6B7D',
  colorNeutralStroke1: '#C5CCD4',
  colorNeutralStroke2: '#E3E7EB',
  borderRadiusMedium: '8px',
  borderRadiusLarge: '10px'
};
